import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsradio-button',
	templateUrl:'./BSRadioButtonPluginCompPage.html',
	styles: [],
	styleUrls:['./BSRadioButtonPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSRadioButtonPluginCompPage
{
	mdContent_856 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.radio.BSRadioButton;
\`\`\``;
	mdContent_857 = `\`\`\`java
BSRadioButton()
\`\`\``;
	mdContent_858 = `\`\`\`java
BSRadioButton&lt;?&gt; r1 = new BSRadioButton&lt;&gt;();
r1.setLabel("Option A").setName("choice");
BSRadioButton&lt;?&gt; r2 = new BSRadioButton&lt;&gt;();
r2.setLabel("Option B").setName("choice");
\`\`\``;
}
